export interface PaginationState {
  pageIndex: number; // always 0-based internally
  pageSize: number;
}

export interface PaginationMeta {
  totalItems: number;
  totalPages: number;
}

export interface PaginationActions {
  goToPage: (page: number) => void;
  next: () => void;
  previous: () => void;
  first: () => void;
  last: () => void;
  changePageSize: (size: number) => void;
}

export interface UsePaginationReturn extends PaginationState, PaginationMeta, PaginationActions {
  visiblePages: number[];
  canPrevious: boolean;
  canNext: boolean;
}

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
